// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape } from 'react-intl';
import Autocomplete from 'react-qempo-autocomplete';
import classNames from 'classnames/bind';
import { getLocalizedCountry } from '../../../../local-values/utils/countries';

import style from '../NewFlightForm.scss';
import inputStyle from '../../../../../assets/styles/input.scss';

import type { FormValidationResult } from '../../../../../utils/form';
import type { Admin, CountryFull } from '../../../../../entities';
import type { LocalValuesState } from '../../../../local-values/duck';

export type SearchResult = {
  type: 'COUNTRY' | 'ADMIN1' | 'ADMIN2';
  country: CountryFull;
  admin1: Admin;
  admin2: Admin;
};

type Props = {
  +localValues: LocalValuesState;
  +translateId: string;
  +loadingTranslateId: string;
  +noResultsTranslateId: string;
  +name: string;
  +searchIsLoading: boolean;
  +items: SearchResult[];
  +handleChange: (e: Event, value: string) => void;
  +handleSelect: (label: string, item: SearchResult) => void;
  +data: {
    value: {
      label?: string;
    };
    errors?: FormValidationResult[];
  };
  +isPosting?: boolean;
  +icon: string;
  +mode: 'edit' | 'create';
};

export default class NewFlightAutocompleteInput extends Component<Props, void> {

  listFormatter = (data: SearchResult, formatMessage: (value: { [id: string]: string }) => string): string => {
    const { localValues } = this.props;
    switch (data.type) {
      case 'COUNTRY':
        return `${getLocalizedCountry(data.country.code, formatMessage, localValues.countriesMap)}`;
      case 'ADMIN1':
        return `${data.admin1.name}, ${getLocalizedCountry(data.country.code, formatMessage, localValues.countriesMap)}`;
      case 'ADMIN2':
        return `${data.admin2.name}, ${data.admin1.name}, ` +
          `${getLocalizedCountry(data.country.code, formatMessage, localValues.countriesMap)}`;
    }
    return '';
  };

  render() {
    const {
      translateId, items, handleChange, handleSelect, data, name, icon,
      searchIsLoading, loadingTranslateId, noResultsTranslateId, isPosting, mode,
    } = this.props;

    return (
      <Autocomplete wrapperProps={{ className: style.inputWrap }}
                    getItemValue={(item: SearchResult) => this.listFormatter(item, this.context.intl.formatMessage)}
                    items={items}
                    renderItem={(item: SearchResult, isHighlighted) =>
                      (<li key={Math.random()}
                           className={classNames(style.autocompleteItem, { [style.over]: isHighlighted })}>
                        {this.listFormatter(item, this.context.intl.formatMessage)}
                      </li>)
                    }
                    value={data.value.label}
                    onChange={handleChange}
                    renderInput={props => <FormattedMessage id={translateId}>
                      {txt => [<input {...props}
                                      type="text"
                                      autoComplete="off"
                                      key="inputAutocomplete"
                                      className={classNames(inputStyle.input, style.input,
                                        { [inputStyle.orange]: !!data.value.label },
                                        { [inputStyle.red]: !!data.errors })}
                                      name={name}
                                      disabled={isPosting || mode === 'edit'}
                                      placeholder={txt}/>,
                        <i key="iconAutocomplete"
                           className={icon}/>]}
                    </FormattedMessage>}
                    renderMenu={children => {
                      if (searchIsLoading) {
                        return (<div className={style.menuLoading}>
                          <FormattedMessage id={loadingTranslateId}/>
                        </div>);
                      } else if (data.value.label) {
                        if (!items.length) {
                          return (<div className={style.menuNoResults}>
                            <FormattedMessage id={noResultsTranslateId}/>
                          </div>);
                        }
                        return (<ul className={style.menu} children={children}/>);
                      } else return <div/>;
                    }}
                    onSelect={handleSelect}/>
    )
  }
}

NewFlightAutocompleteInput.propTypes = {
  localValues: PropTypes.object,
  translateId: PropTypes.string.isRequired,
  loadingTranslateId: PropTypes.string.isRequired,
  noResultsTranslateId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  searchIsLoading: PropTypes.bool.isRequired,
  items: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSelect: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  isPosting: PropTypes.bool,
  icon: PropTypes.string.isRequired,
  mode: PropTypes.string.isRequired,
};

NewFlightAutocompleteInput.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/new-flight/components/NewFlightForm/NewFlightAutocompleteInput/NewFlightAutcompleteInput.jsx